import api from "./api";

// 删除知识库目录
export const knowledgeDeleteFolder = async (folderIds: number[]) => {
  const res = await api.post<unknown>("/knowledge/delete_folder", {
    folder_ids: folderIds,
  });
  return res;
};
